import { PrintIcon } from "assets/icons";
import { t } from "i18next";
import { BoxShadowLayout, ContentLayout } from "layouts";
import { Button, DateRangeInput, SearchInput } from "ui";

import { DeliveryCompaniesTable } from "../../components";
import { useDriversDeliveriesInfo } from "../../hooks";

import styles from "./Deliveries.module.scss";

const Deliveries = () => {
  const {
    dateRange,
    search,
    setDateRange,
    setSearch,
    driversDeliveriesInfo,
    deliveriesReport,
    isLoading
  } = useDriversDeliveriesInfo();

  return (
    <ContentLayout title={t("Deliveries")}>
      <BoxShadowLayout className={styles.pageContent}>
        <div className={styles.pageContent_tableHeader}>
          <SearchInput
            value={search}
            onChange={setSearch}
            placeholder={t("Search...")}
          />

          <div className={styles.pageContent_tableHeader_rightBlock}>
            <DateRangeInput value={dateRange} onChange={setDateRange} />

            <Button
              className={styles.pageContent_tableHeader_printBtn}
              icon={<PrintIcon />}
              disabled={!driversDeliveriesInfo || deliveriesReport.isLoading}
              onClick={() => deliveriesReport.mutate()}
            >
              {t("Print Report")}
            </Button>
          </div>
        </div>

        <DeliveryCompaniesTable
          items={driversDeliveriesInfo ?? []}
          isLoading={isLoading}
        />
      </BoxShadowLayout>
    </ContentLayout>
  );
};

export default Deliveries;
